import videoDetailsLocale from './en.json'

const en = {
  videoDetails: videoDetailsLocale,
}

export default en
